export default function isCheckboxItem(element) {
  var role = element.getAttribute('role');
  return role === 'checkbox' || role === 'menuitemcheckbox';
}